exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nb-used-time-chart .operation-item[data-v-e081f644]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-bottom:15px}.nb-used-time-chart .operation-item .title[data-v-e081f644]{font-size:18px}.nb-used-time-chart .stats-line[data-v-e081f644]{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:16px;margin-left:40px;margin-top:10px}.nb-used-time-chart .stats-line div[data-v-e081f644]{margin-right:50px}\n", ""]);

// exports
